import usePageTracking from '../../utils/google-analytics';

export function GoogleAnalytics() {
  usePageTracking();

  return null;
}
